module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAdElEQVR42u3awQkAIAwEwdTkU7A1KxdiFYFA5mAbmPdFZsbkAgAAAAAAAAAAAAAAAKV7Z7UKAAAAAAAAAAAAAAAAAAAAAAAAAAAAtYu7WwUAAAAAAAAAAAAAAAAAAAAAAAAAAABHSQAAAAAAAAAAAAAABvUBiexcowmxJq0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Madagascar.png
// module id = e7Kf
// module chunks = 0 62 63